import service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
  routeList: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_ROUTE_LIST(state, payload) {
    state.routeList = payload;
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return service
      .get("routes/geofence", params)
      .then((data) => {
        if (params?.page) {
          store.commit("SET_META", data.body);
          store.commit("SET_LIST", data.body.data);
        } else {
          store.commit("SET_LIST", data.body);
        }
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  add: (store, params) => {
    store.state.loading = true;
    return service
      .post("routes/geofence", params)
      .then((data) => {
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
  update: (store, params) => {
    store.state.loading = true;
    return service
      .update("routes/geofence", params)
      .then((data) => {
        return data;
      })
      .finally(() => (store.state.loading = false));
  },
  destroy: (store, params) => {
    store.state.loading = true;
    return service
      .destroy(`routes/geofence`, params)
      .then((res) => {
        // store.commit("DELETE", params);
        return res;
      })
      .finally(() => (store.state.loading = false));
  },

  //
  routeList: (store, params) => {
    store.state.loading = true;
    return service
      .get("routes/geofence-route-list", params)
      .then((data) => {
        store.commit("SET_ROUTE_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  //
  getRouteList(state) {
    return state.routeList;
  },
};

const geofence = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default geofence;
